import Reveal from '@/pages/zz-review/components/Reveal';

const features = [
  {
    icon: 'ri-map-2-line',
    title: '隨書導航卡',
    body: '每本募資實體書附贈 RG Portal 實踐起點導航卡，把書中練習帶入日常事件。',
  },
  {
    icon: 'ri-chat-heart-line',
    title: '3 次 AI Angel 體驗',
    body: '免費使用 3 次 AI Angel 中軸導航與 Evidence 建立體驗；完成後由讀者自主決定是否採用後續工具，無強制購買。',
  },
  {
    icon: 'ri-team-line',
    title: '企業 90 日實踐入口',
    body: '企業／團隊 90 日 RG 實踐入口指南，協助團隊建立主動協作與閉環交付能力。',
  },
];

export default function PortalSection() {
  return (
    <section id="portal" className="w-full py-16 md:py-24 bg-background-50 scroll-mt-20">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="text-center mb-6">
            <p className="text-xs tracking-[0.2em] uppercase text-foreground-400 mb-3">
              RG Portal 數位實踐入口
            </p>
            <h2
              className="text-2xl md:text-4xl text-foreground-900"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              閱讀完成，不等於能力完成
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-2xl mx-auto">
              《1001旋轉門》不是讀完即結束。隨書附贈專屬導航卡，讓一本書從閱讀內容延伸成為可以持續實踐的生命導航。
            </p>
          </div>
        </Reveal>

        <Reveal delay={60}>
          <div className="rounded-lg border border-accent-200/70 bg-accent-50 px-6 md:px-10 py-8 text-center mb-10">
            <div className="w-12 h-12 flex items-center justify-center rounded-md bg-accent-100 text-accent-800 mx-auto mb-4">
              <i className="ri-eye-2-line text-2xl" />
            </div>
            <h3
              className="text-xl md:text-2xl text-foreground-900 mb-3"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              讓 AI 成為鏡子，不是主人
            </h3>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-3xl mx-auto">
              RG Portal 協助讀者整理事件與 Evidence，讓科技支持本心，而不是代替人為自己負責，更不是替生命作決定。
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {features.map((f, i) => (
            <Reveal key={f.title} delay={i * 80}>
              <div className="h-full rounded-lg border border-background-200/70 bg-background-100 p-6 md:p-7 flex flex-col">
                <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-100 text-primary-800 mb-5">
                  <i className={`${f.icon} text-2xl`} />
                </div>
                <h4
                  className="text-base md:text-lg text-foreground-900 mb-3"
                  style={{ fontFamily: 'var(--font-heading)' }}
                >
                  {f.title}
                </h4>
                <p className="text-sm text-foreground-600 leading-relaxed">{f.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}